import dayjs from "dayjs";
import {EntityBase} from "../../../shared/entity/EntityBase";

const CHARACTER_PACKAGE_FIELDS = {
    seq: { type: parseInt, defaultValue: 0 },
    index: { type: Number, defaultValue: 0 },
    packageName: { defaultValue: '' },
    onOff: { defaultValue: 0 },
    begin: { type: Number, defaultValue: dayjs().hour(9).startOf('hour').unix() },
    end: { type: Number, defaultValue: dayjs().add(1, 'day').hour(8).endOf('hour').unix() },
    packageTime: { type: Number, defaultValue: 0 },
    miniGameIdx: { type: Number, defaultValue: 0 },
    intervalValue: { type: Number, defaultValue: 0 },
    intervalUnit: { defaultValue: 'hour' },
    memo: { defaultValue: '' },
};

export class CharacterPackageEntity extends EntityBase {
    constructor(data = {}) {
        super(data, CHARACTER_PACKAGE_FIELDS);

        this.errors = [
            {condition: () => this.index === 0, message: '인덱스가 없습니다.'},
        ];
    }

    getIdentityKey() {
        return 'index';
    }
}